import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=cc98a310&"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=cc98a310&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports